<template>
    <transition name="modal">
        <div class="modal__mask modalRepresentantesPJ" v-if="showModalCreate">
            <div class="modal__wrapper">
                <div class="modal__container reset">
                    <div class="content__modal_representante">
                        <a @click.stop.prevent="closeModal" class="close__modal">x</a>
                        <div class="inner__modal">
                            <div style="display: inline-flex">
                                <div style="width: 20%">
                                    <img style="width: 50px; height: 50px; margin-top: 0px;"
                                        src="@/assets/addRepresentante.png" />
                                </div>
                                <div style="width: 80%">
                                    <h2
                                        style="margin-left: 5px; margin-top: 10px; font-size: 16px; width: 200px; margin-bottom: 10px;">
                                        Adicionar representante ou emissor de ordem.</h2>
                                </div>
                            </div>
                            <form action="" class="form__class" @submit.stop.prevent="createRepresentante">
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Selecione tipo*</label>
                                        <select class="field" v-model="representante.Tipo" @change="handleTipoChange"
                                            :disabled="representante.Guid != ''">
                                            <option value="">Selecione</option>
                                            <option value="Representante">Representante</option>
                                            <option value="Pessoa autorizada emitir ordem">Autorizado a emitir ordens
                                            </option>
                                        </select>
                                        <p v-if="camposObrigatorios.erroTipo" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Nome*</label>
                                        <input type="text" class="field" autocomplete="off" v-model="representante.Nome"
                                            @click.stop.prevent="clear" />
                                        <p v-if="camposObrigatorios.erroNome" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">CPF/CNPJ/Outros*</label>
                                        <input type="text" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-model="representante.CpfCnpj" />
                                        <p v-if="camposObrigatorios.erroCpfCnpj" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">E-mail*</label>
                                        <input type="text" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-model="representante.Email" />
                                        <p v-if="camposObrigatorios.erroEmail" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls">
                                        <label class="label">Telefone*</label>
                                        <input type="text" class="field" autocomplete="off" @click.stop.prevent="clear"
                                            v-mask="'(##) #####-####'" v-model="representante.Telefone" />
                                        <p v-if="camposObrigatorios.erroTelefone" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls" style="width: 100%">
                                        <label class="label" for="assinante">Assinatura*</label>
                                        <select id="assinante" class="field" v-model="representante.Assinatura"
                                            :disabled="representante.Tipo === 'Pessoa autorizada emitir ordem'">
                                            <option value=""></option>
                                            <option value="1">Não assina pela empresa</option>
                                            <option value="2">Assina isoladamente</option>
                                            <option value="0">Assina em conjunto</option>
                                        </select>
                                        <p v-if="camposObrigatorios.erroAssinatura" class="erro">Campo obrigatório.</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls" style="width: 100%">
                                        <label class="label" for="nome">É considerado US PERSON?*</label>
                                        <div class="radio">
                                            <input type="radio" id="false" :name="UsPerson" class="field__radio"
                                                value="false" @change="salvarAlteracoesLocalmente"
                                                v-model="representante.UsPerson" />
                                            <label for="Nao" class="label">Não</label>
                                            <input type="radio" id="true" value="true" :name="UsPerson"
                                                class="field__radio field__radio_second"
                                                @change="salvarAlteracoesLocalmente" v-model="representante.UsPerson" />
                                            <label for="Sim" class="label">Sim</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls" style="width: 100%">
                                        <label class="label" for="nome">É uma Pessoa Exposta Politicamente?*</label>
                                        <div class="radio">
                                            <input type="radio" id="false" :name="PoliticamenteExposta"
                                                class="field__radio" value="false" @change="salvarAlteracoesLocalmente"
                                                v-model="representante.PoliticamenteExposta" />
                                            <label for="Nao" class="label">Não</label>
                                            <input type="radio" id="true" value="true" :name="PoliticamenteExposta"
                                                class="field__radio field__radio_second"
                                                @change="salvarAlteracoesLocalmente"
                                                v-model="representante.PoliticamenteExposta" />
                                            <label for="Sim" class="label">Sim</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form__controls" style="width: 100%">
                                        <label class="label" for="nome">Será o responsável pelo login?*</label>
                                        <div class="radio">
                                            <input type="radio" id="false" :name="ResponsavelLogin" class="field__radio"
                                                value="false" 
                                                v-model="representante.ResponsavelLogin"
                                                :disabled="representante.Tipo === 'Pessoa autorizada emitir ordem' || existeResponsavelLogin" />
                                            <label for="Nao" class="label">Não</label>
                                            <input type="radio" id="true" value="true" :name="ResponsavelLogin"
                                                class="field__radio field__radio_second"
                                                
                                                v-model="representante.ResponsavelLogin"
                                                :disabled="representante.Tipo === 'Pessoa autorizada emitir ordem' || existeResponsavelLogin" />
                                            <label for="Sim" class="label">Sim</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="buttonsAcoes">
                                    <button class="btnDefault" type="button" :disabled="disableBtn"
                                        @click="closeModal">Cancelar</button>
                                    <button v-if="representante.Guid != ''" class="btnBlue" type="button"
                                        :disabled="disableBtn" @click="salvarRepresentante">Atualizar</button>
                                    <button v-if="representante.Guid == ''" class="btnBlue" type="button"
                                        :disabled="disableBtn" @click="salvarRepresentante">Adicionar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api/axios';
export default {
    computed: {
        ...mapGetters({
            showModalCreate: "GET_MODAL_PJ_ADD_PESSOA",
            editarRepresentante: 'GET_MODAL_PJ_EDITAR_PESSOA',
            user: 'auth/user',
            existeResponsavelLogin: 'existeResponsavelLogin'
        }),
        celularMask() {
            const telefoneLimpo = this.representante.Telefone?.replace(/\D/g, '');
            if (telefoneLimpo?.length <= 11) {
                return '(##) #####-####';
            }
            else {
                return '+(##) (##) ####-#####';
            }
        },
    },
    data() {
        return {
            permitirAvancar: false,
            camposObrigatorios: {
                erroTipo: false,
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroTelefone: false,
                erroAssinatura: false
            },
            representante: {
                Guid: '',
                ClienteId: '',
                Nome: '',
                Email: '',
                CpfCnpj: '',
                UsPerson: false,
                PoliticamenteExposta: false,
                ResponsavelLogin: false,
                Tipo: '',
                Telefone: '',
                Assinatura: ''
            }
        }
    },
    mounted() {
        this.representante.ClienteId = this.user.ClienteId;
    },
    watch: {
        editarRepresentante() {
            this.representante = this.editarRepresentante;
        }
    },
    methods: {
        handleTipoChange() {
            if (this.representante.Tipo === 'Pessoa autorizada emitir ordem') {
                this.representante.Assinatura = 1;
                this.representante.ResponsavelLogin = false;
            }
        },
        closeModal() {
            this.camposObrigatorios.erroTipo = false;
            this.camposObrigatorios.erroNome = false;
            this.camposObrigatorios.erroCpfCnpj = false;
            this.camposObrigatorios.erroEmail = false;
            this.camposObrigatorios.erroTelefone = false;
            this.camposObrigatorios.erroAssinatura = false;
            //this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", false);
            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", { showModal: false, existeResponsavel: this.existeResponsavelLogin });
            this.$store.commit("SET_MODAL_PJ_EDITAR_PESSOA", null);
        },
        limparObj() {
            this.representante = {
                Guid: '',
                ClienteId: this.user.ClienteId,
                Nome: '',
                Email: '',
                CpfCnpj: '',
                UsPerson: false,
                PoliticamenteExposta: false,
                ResponsavelLogin: false,
                Tipo: '',
                Assinatura: ''
            };
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            var nomeDoCampo = '';
            this.camposObrigatorios = {
                erroTipo: false,
                erroNome: false,
                erroCpfCnpj: false,
                erroEmail: false,
                erroTelefone: false,
                erroAssinatura: false
            };
            if (this.representante.Tipo === null || this.representante.Tipo === undefined || this.representante.Tipo === '') {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTipo = true;
                    nomeDoCampo = 'Tipo';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Nome) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroNome = true;
                    nomeDoCampo = 'Nome';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.CpfCnpj) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroCpfCnpj = true;
                    nomeDoCampo = 'CPF/CNPJ';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Email) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroEmail = true;
                    nomeDoCampo = 'E-mail';
                }
                this.permitirAvancar = false;
            }
            if (!this.representante.Telefone) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTelefone = true;
                    nomeDoCampo = 'Telefone';
                }
                this.permitirAvancar = false;
            }
            if ((this.representante.Assinatura === null || this.representante.Assinatura === undefined || this.representante.Assinatura === '') && this.representante.Tipo !== 'Pessoa autorizada emitir ordem') {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroAssinatura = true;
                    nomeDoCampo = 'Assinatura';
                }
                this.permitirAvancar = false;
            }
            if (submeter && nomeDoCampo != '') {
                this.$swal({
                    icon: 'warning',
                    title: 'Oops...',
                    text: `O campo ` + nomeDoCampo + ` não foi informado, preencha a informação para avançar.`,
                });
            }
        },
        async salvarRepresentante() {
            this.validarFormulario(true);
            if (this.permitirAvancar) {
                this.disableBtn = true;
                var encodedCredentials = btoa('sat@sat:sat23!');
                await api
                    .post('/PessoaJuridica/representante', this.representante, { headers: { 'Authorization': `Basic ${encodedCredentials}` } })
                    .then((retorno) => {
                        this.disableBtn = false;
                        if (retorno.status == 200) {
                            this.$swal({
                                icon: 'success',
                                title: this.representante.Guid == '' ? 'Inclusão realizada com sucesso!' : 'Alteração realizada com sucesso!',
                                text: 'Dados informados foram salvos com sucesso.',
                            });
                            this.limparObj();
                            //this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", false);
                            this.$store.commit("SET_MODAL_PJ_ADD_PESSOA", { showModal: false, existeResponsavel: this.existeResponsavelLogin });
                            this.$store.dispatch('FETCH_PJ_LISTA_REPRESENTANTES', this.user.ClienteId);
                        }
                    })
                    .catch((error) => {
                        this.disableBtn = false;
                        this.$swal({
                            icon: 'error',
                            title: 'Dados informados inválidos informado para representante.',
                            text: `${error.response.data.data[0]}`,
                        });
                    });
            }
        }
    },
};
</script>

<!--<style lang="scss">
@include modal;

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.subTitle {
    color: #383333;
    ;
    margin-top: -30px;
    margin-bottom: 30px;
    font-size: large;
    font-family: "Work Sans", sans-serif;
    font-weight: 400 !important;
}

.modalRepresentantesPJ .modal__wrapper .modal__container.reset {
    width: 400px !important;
    height: 636px !important;
}

.titleConta {
    font-weight: 800 !important;
    text-transform: uppercase;
}

.btnLogin {
    background-color: #565656 !important;
}

.subTitleCinza {
    width: 52%;
    text-align: center;
    font-weight: 400 !important;
    color: #707070 !important;
    font-family: "Work Sans", sans-serif;
}

.content__modal_representante {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    overflow-y: auto;
    height: 500px;
    padding-top: 110px;

    .close__modal {
        position: absolute;
        right: 34px;
        top: 30px;
        font-family: "Montserrat";

        @media (max-width: 768px) {
            top: 16px;
            right: 16px;
        }
    }

    h3 {
        margin-bottom: 46px;

        @media (max-width: 768px) {
            font-size: 24px;
            margin-bottom: 20px;
            text-align: center;
            max-width: 280px;
        }
    }
}
</style>-->